module.exports = __webpack_public_path__ + "media/images/static/top/local/photo5-4220c12f34bc79b28c834cc0555f0db2.png";